import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { saveConfigs } from './ConfigState.actions';
import { createReducer } from '@reduxjs/toolkit';
import { UILayout } from '../../constants/AppConstants';
export var initialState = {
  authorization: {
    apiKey: '',
    cheggBaseUrl: '',
    cheggGraphQLUrl: ''
  },
  appConstants: {
    cdnUrl: '',
    braintreeToken: '',
    paypalClientId: '',
    applePayJSVersion: 3,
    flagUrl: '',
    billdesk: {
      merchantId: '',
      scriptsSubDomain: ''
    },
    recurly: {
      publicKey: '',
      braintreeToken: ''
    },
    googlePay: {
      merchantId: '',
      googlePayVersion: 2,
      googlePayURL: ''
    }
  },
  rioNamespace: undefined,
  paymentMethods: [],
  paymentMethodMap: {},
  paymentProcessors: [],
  yiftee: {
    yifteeCoveringFull: false,
    balance: -1
  },
  ui: {
    layout: UILayout.FULL,
    showSubmitButton: true,
    displayServerErrors: true,
    displayLoadingIndicator: true,
    addressFetchCompleted: false,
    showUpiProcessing: false
  },
  country: 'US',
  mopCreated: false,
  didAddressUpdate: false,
  submit: false,
  regexValidation: true,
  mandatoryCountries: [''],
  hiddenCountries: [''],
  supportedPaymentMethods: [],
  shouldValidateExistingMopsZipcodes: true,
  venmoVisible: true,
  googlepayVisible: false,
  upi: false
};
var reducer = createReducer(initialState, function (builder) {
  builder.addCase(saveConfigs, function (state, action) {
    return _objectSpread(_objectSpread({}, state), action.payload);
  });
});
export default reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/ConfigState/ConfigState.reducer.js
// module id = 4528
// module chunks = 11